<template>
  <div>
    <div v-if="!isNew" class="text-end">
      <button class="btn btn-light mb-2" @click="()=>{showAuditModal=true;}">Audit</button>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-3">
              <div class="col-sm-3 text-secondary">
                Name:
              </div>
              <div class="col-sm-6">
                <input type="text" class="form-control" :class="error.name && 'control-error'" v-model="dataObj.name" />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3 text-secondary">
                Corporate Type:
              </div>
              <div class="col-sm-6">
                <FormSelect :list="corporateTypes" :cssClass="error.corporateType && 'control-error'" value="value" text="text" :existing="dataObj.corporateType" @change="changeType" />
              </div>
            </div>
            <div v-if="isWI" class="row mb-3">
              <div class="col-sm-3 text-secondary">
              </div>
              <div class="col-sm-6">
                <input type="checkbox" v-model="dataObj.isWI" /> This role is for Welding Inspector
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3 text-secondary">
                Permissions:
              </div>
              <div class="col-sm-9" :class="error.permissionOids && 'control-error'">
                    <div v-for="(gp,idx) in groupPermissions" :key="idx" class="row row-col-6">
                        <div style="padding-top:30px;" class="mt-1"><strong>{{gp.header}}</strong></div>
                        <div v-for="p in gp.permissions" :key="p.oid" class="col-md-6">
                          <input type="checkbox" v-model="p.checked" /> <label class="control-label">{{p.permissionDesc}} <span v-if="p.description">{{' ('+ p.description +')'}}</span></label><br/>
                          <label class="text-secondary">{{p.comments}}</label>
                        </div>
                    </div>
                 <!-- <div v-for="p in permissions" :key="p.oid">
                      <div style="padding-top:30px;" v-if="p.headerGroup" class="mt-1"><strong>{{p.headerGroup}}</strong></div>
                      <input type="checkbox" v-model="p.checked" /> <label class="control-label">{{p.permissionDesc+' ('+ p.permissionCode +')'}}</label>
                 </div> -->
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-secondary m-1 float-end" @click="clickCancel">Cancel</button>
        <button class="btn btn-success m-1 float-end" @click="clickSave">Save</button>
        <button v-if="!isNew" class="btn btn-danger m-1" @click="confirmRemove">Delete</button>
      </div>
    </div>
    <ModalDiaglog size="xl" :show="showAuditModal" :onClose="()=>{showAuditModal=false}" :hasHeader="false" :showSubmitBtn1="false">
      <div v-if="showAuditModal">
        <AuditLog 
        :timezone="timezone" 
        tablename="Role" 
        :primarykey="oid" 
        :categories="[]"
        :defaultCategory="'All'" 
        :basicLogInfoOid="oid" 
        :basicLogInfoUrl="basicLogInfoUrl" 
        />
      </div>
    </ModalDiaglog>      
  </div>
</template>

<script>
import apiUrl from '@/common/apiurl';
import api from '@/common/api';
import _ from 'lodash';
import AuditLog from '@/components/custom/AuditLog';
import ModalDiaglog from '@/components/custom/ModalDiaglog';
import * as Forms from '@/components/custom/forms';
export default {
  name: 'AddEditRole',
  components: {
    AuditLog,
    ModalDiaglog,
    ...Forms
  },

  props: {

  },

  data() {
    return {
      basicLogInfoUrl: apiUrl.roles.getBasicLogInfo,
      oid: 0,
      isNew: true,
      confirmObj: {},
      dataObj: {},
      timezone: api.TIMEZONE,
      alertCounter: 0,
      alertMessage: "",
      permissions: [],
      groupPermissions: {},
      showAuditModal: false,
      corporateTypes: [],
      isWI:false,
      error: {}
    };
  },
  destroyed() {
    this.clearBreadcrumb();
  },
  beforeMount() {
    let passedId = this.$route.params.id;
    if (passedId && passedId > 0) {
      this.oid = parseInt(passedId);
      this.isNew = false;
    }
  },
  mounted() {

    let pageName = this.isNew ? 'New Role' : 'Edit Role';
    this.setBreadcrumb([
      { name: 'Roles', url: '/roles' }, { name: pageName }
    ]);

    // if (this.isNew) {
    //   this.dataObj.isActive = true;
    // }
    if (this.oid > 0) {
      this.getData();
    } else {
      this.getPermissions();
    }

    this.corporateTypes.push({ value: this.$data._corporateType.industry.value, text: this.$data._corporateType.industry.text });
    this.corporateTypes.push({ value: this.$data._corporateType.contractor.value, text: this.$data._corporateType.contractor.text });
    this.corporateTypes.push({ value: this.$data._corporateType.testCenter.value, text: this.$data._corporateType.testCenter.text });
    this.corporateTypes.push({ value: this.$data._corporateType.admin.value, text: this.$data._corporateType.admin.text });
    this.corporateTypes.push({ value: this.$data._corporateType.sws.value, text: this.$data._corporateType.sws.text });
    this.corporateTypes.push({ value: this.$data._corporateType.mom.value, text: this.$data._corporateType.mom.text });
    //this.corporateTypes.push({ value: this.$data._corporateType.weldingInspector.value, text: this.$data._corporateType.weldingInspector.text });

  },

  methods: {
    changeType(e){
      this.dataObj.corporateType=e;
      if(e == this.$data._corporateType.industry.value || e == this.$data._corporateType.testCenter.value){
        this.isWI = true;
      }else{
        this.isWI = false;
        this.dataObj.isWI = false;
      }
    },
    getData() {
      let url = apiUrl.roles.getByOid + '/' + this.oid
      api.regularGet(url, null).then((response) => {
        this.dataObj = response.data;
        this.getPermissions();
        this.isWI = this.dataObj.isWI;
        if(this.dataObj.corporateType == this.$data._corporateType.industry.value || this.dataObj.corporateType == this.$data._corporateType.testCenter.value){
          this.isWI = true;
        }
      });
    },
    getPermissions() {
      api.getAllPermissions(null, this.$store.state.token).then((response) => {
        if (response.status == 200) {
          this.permissions = response.data;
          this.permissions = this.permissions.sort(x => x.headerGroup);

          for (let i = 0; i < this.permissions.length; i++) {

            //render checked
            if (!this.isNew && this.dataObj.permissions) {
              let per = this.dataObj.permissions.find(x => x.oid == this.permissions[i].oid)
              if (per)
                this.permissions[i].checked = true;
            }
          }
          let headerList = _.uniqBy(this.permissions, "headerGroup").map(x => x.headerGroup);
          this.groupPermissions = [];
          for (let h = 0; h < headerList.length; h++) {
            let obj = {
              header: headerList[h],
              permissions: this.permissions.filter(x => x.headerGroup == headerList[h])
            };
            this.groupPermissions.push(obj);
          }
          //let header = "";
          // for (let i = 0; i < this.permissions.length; i++) {
          //   if(header == this.permissions[i].headerGroup){
          //     this.permissions[i].headerGroup = '';
          //   }else{
          //     header = this.permissions[i].headerGroup;
          //   }
          //   // if (i > 0 && this.permissions[i].headerGroup == this.permissions[i - 1].headerGroup) {
          //   //   this.permissions[i].headerGroup = '';
          //   // }

          //   //render checked
          //   if (!this.isNew && this.dataObj.permissions) {
          //     let per = this.dataObj.permissions.find(x => x.oid == this.permissions[i].oid)
          //     if (per)
          //       this.permissions[i].checked = true;
          //   }
          // }
        }
      });
    },
    clickSave() {
      let permissionOids = [];
      this.groupPermissions.forEach(h => {
        h.permissions.forEach(p => {
          if (p.checked) {
            permissionOids.push(p.oid);
          }
        });
      });
      this.dataObj.permissionOids = permissionOids;

      if (!this.validate())
        return;

      let subUrl = '';
      if (this.isNew) {
        subUrl = apiUrl.roles.insert;
      }
      else {
        subUrl = apiUrl.roles.update;
      }

      this.showLoadingScreen();
      api.regularPost(subUrl, this.dataObj, this.$store.state.token).then((response) => {
        this.hideLoadingScreen();
        if (response.status == 200) {
          this.showMessage("Successfully saved.", "success");
          this.$router.push({ name: "ManageRoles" });
        }
        else if (response.status == 400 || response.errorText.response.status == 400) {
          this.showMessage(response.errorText.response.data.message, "error");
        }
        else {
          this.showMessage(window.message.unable_proceed, "error");
        }
      });

    },
    clickCancel() {
      this.$router.push({ name: "ManageRoles" });
    },
    validate() {
      let isValid = true;
      Object.keys(this.error).forEach(k => this.error[k] = false);

      if (!this.dataObj.name) { this.error.name = true; isValid = false; }
      if (!this.dataObj.permissionOids || this.dataObj.permissionOids.length == 0) { this.error.permissionOids = true; isValid = false; }

      this.$forceUpdate();
      return isValid;
    },
    showErrorMessage(msg) {
      this.alertCounter = 5;
      this.alertMessage = msg;
    },
    confirmRemove() {
      this.showConfirmDiaglog(
        {
          show: true,
          message: 'Are you sure to remove ' + this.dataObj.name + '?',
          submitFunction: () => {
            api.regularPost(apiUrl.roles.delete, this.dataObj, this.$store.state.token).then((response) => {
              if (response.status == 200) {
                this.showMessage("Successfully Deleted.", "success");
                this.$router.push({ name: "ManageRoles" });
              }
              else if (response.status == 400 || response.errorText.response.status == 400) {
                this.showMessage(response.errorText.response.data.message, "error");
              }
              else {
                this.showMessage(window.message.doctors.unable_delete, "error");
              }
            });
          }
        });
    },
    showAudit() {
      this.showAuditDialog(true);
    }
  }
}
</script>
